import { render, staticRenderFns } from "./InventoryItemForm.vue?vue&type=template&id=375f061a&scoped=true&"
import script from "./InventoryItemForm.vue?vue&type=script&lang=ts&"
export * from "./InventoryItemForm.vue?vue&type=script&lang=ts&"
import style0 from "./InventoryItemForm.vue?vue&type=style&index=0&id=375f061a&lang=scss&scoped=true&"
import style1 from "./InventoryItemForm.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "375f061a",
  null
  
)

export default component.exports